import { render, staticRenderFns } from "./UpdateInfoDialog.vue?vue&type=template&id=51d59236&scoped=true&"
import script from "./UpdateInfoDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d59236",
  null
  
)

export default component.exports